import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-account-deactivation-modal',
    templateUrl: './account-deactivation-modal.component.html',
    styleUrls: ['./account-deactivation-modal.component.scss'],
    standalone: false
})
export class AccountDeactivationModalComponent implements OnInit {

  accountDeactivation: any;
  constructor(
    public dialogRef: MatDialogRef<AccountDeactivationModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.accountDeactivation = this.data;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
